// AdComponent.jsx
const AdComponent = () => {
  return (
    <div className="adArea">
      <a href="広告のリンク">
        <img src="/images/ad1.png" alt="広告" />
      </a>
      <a href="https://hangul-match.com/subscription">
        <img src="/images/ad2.png" alt="広告" />
      </a>
      <a href="https://school.k-topmedia.com/price/">
        <img src="/images/ad3.png" alt="広告" />
      </a>
    </div>
  );
};

export default AdComponent;